import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ProjectWithYearsDto } from '../models/project-with-years-dto.model';
import { ApiServiceBase } from './base/api-service-base';

@Injectable({ providedIn: 'root' })
export class ProjectWithYearsService extends ApiServiceBase {
  //#region Constructor
  constructor(
    private readonly _httpClient: HttpClient
  ) {
    super();
  }
  //#endregion

  //#region Private properties
  private readonly _projectWithYearsControllerUrl: string = "/api/ProjectWithYears";
  //#endregion

  //#region Public methods
  public getByQuotation$(quotationID: string): Observable<ProjectWithYearsDto> {
    const url: string = `${this._projectWithYearsControllerUrl}/quotation/${quotationID}`;

    return super.catchErrorResponse(this._httpClient.get<ProjectWithYearsDto>(url));
  }
  //#endregion
}
